import { Badge } from '@/components/ui/badge';
import { displayCurrency, formatDateShort } from '@/utils/format.utils';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { ModelSettlementReport } from '@layup/api-sdk';

export const settlementsTableColumns: ColumnDef<ModelSettlementReport>[] = [
  {
    accessorKey: 'reference',
    header: () => 'Reference',
    enableSorting: false,
    cell: ({ row }) => {
      const rowData = row.original;
      const ref = rowData.reference;
      return h(RouterLink, { to: `/merchant/settlements/${rowData.id}`, class: 'text-brand-700 underline' }, () => ref);
    },
  },
  {
    accessorKey: 'settledAt',
    header: () => 'Settled Date',
    enableSorting: false,
    cell: ({ getValue }) => {
      const dateSettled = getValue() as string;
      return h('div', formatDateShort(dateSettled));
    },
  },
  {
    accessorKey: 'batchType',
    header: () => 'Batch Type',
    enableSorting: false,
    cell: ({ getValue }) => {
      const batchType = getValue() as
        | 'ALL'
        | 'COMPLETED'
        | 'DEPOSITCOMPLETED'
        | 'COMPLETEDCANCELLED'
        | 'DEPOSITCOMPLETEDCANCELLED';

      const titles = {
        ALL: 'All',
        COMPLETED: 'Completed',
        COMPLETEDCANCELLED: 'Completed Cancelled',
        DEPOSITCOMPLETEDCANCELLED: 'Deposit Completed Cancelled',
        DEPOSITCOMPLETED: 'Deposit Completed',
      };

      return h(Badge, { class: 'text-xs', variant: 'info' }, () => titles[batchType]);
    },
  },
  {
    accessorKey: 'batch',
    header: () => {
      return h('div', { class: 'text-right' }, 'Batch No');
    },
    enableSorting: false,
    cell: ({ getValue }) => {
      const batch = getValue() as string;
      return h('div', { class: 'text-right' }, batch);
    },
  },
  {
    accessorKey: 'amount',
    header: () => {
      return h('div', { class: 'text-right' }, 'Amount');
    },
    enableSorting: false,
    cell: ({ getValue }) => {
      const settlementAmount = getValue() as number;
      return h('div', { class: 'text-right' }, displayCurrency(settlementAmount));
    },
  },
];
